export default {
  init() {

    $('#gospel-hour__date-select').on('change', function () {
      if (this.value === 'all') {
        $('.gospel-hour__date').show();
      } else {
        $('#gospel-hour__network-select').find('option:eq(0)').prop('selected', true);
        $('#gospel-hour__show-select').find('option:eq(0)').prop('selected', true);
        $('.gospel-hour__date').hide();
        $('.gospel-hour__date').filter('[data-date="' + this.value + '"]').show();
      }
    });

    $('#gospel-hour__network-select').on('change', function () {
      if (this.value === 'all') {
        $('.gospel-hour__date').show();
      } else {
        $('#gospel-hour__date-select').find('option:eq(0)').prop('selected', true);
        $('#gospel-hour__show-select').find('option:eq(0)').prop('selected', true);
        $('.gospel-hour__date').hide();
        $('.gospel-hour__date').filter('[data-network="' + this.value + '"]').show();
      }
    });

    $('#gospel-hour__show-select').on('change', function () {
      if (this.value === 'all') {
        $('.gospel-hour__date').show();
      } else {
        $('#gospel-hour__date-select').find('option:eq(0)').prop('selected', true);
        $('#gospel-hour__network-select').find('option:eq(0)').prop('selected', true);
        $('.gospel-hour__date').hide();
        $('.gospel-hour__date').filter('[data-show="' + this.value + '"]').show();
      }
    });
    
    
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/post-type-archive-showtime.js